var _path, _path2, _path3, _g, _path4, _rect, _g2, _circle, _path5, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirmEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 195,
    viewBox: "0 0 210 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.231 171.689C145.828 171.689 177.927 139.758 177.927 100.368C177.927 60.9791 145.828 29.0479 106.231 29.0479C66.6345 29.0479 34.5352 60.9791 34.5352 100.368C34.5352 139.758 66.6345 171.689 106.231 171.689Z",
    fill: "#E4E4E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.511788,
    d: "M32.8139 37.5787C38.9124 37.5787 43.8562 32.6439 43.8562 26.5564C43.8562 20.469 38.9124 15.5342 32.8139 15.5342C26.7153 15.5342 21.7715 20.469 21.7715 26.5564C21.7715 32.6439 26.7153 37.5787 32.8139 37.5787Z",
    fill: "url(#paint0_linear_13739_143902)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.511788,
    d: "M173.798 175.442C176.493 175.442 178.678 173.257 178.678 170.562C178.678 167.867 176.493 165.683 173.798 165.683C171.103 165.683 168.918 167.867 168.918 170.562C168.918 173.257 171.103 175.442 173.798 175.442Z",
    fill: "url(#paint1_linear_13739_143902)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.511788,
    filter: "url(#filter0_f_13739_143902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7982 187.454C63.7246 187.454 75.8249 175.354 75.8249 160.427C75.8249 145.501 63.7246 133.4 48.7982 133.4C33.8718 133.4 21.7715 145.501 21.7715 160.427C21.7715 175.354 33.8718 187.454 48.7982 187.454Z",
    fill: "url(#paint2_linear_13739_143902)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.511788,
    d: "M174.172 46.3149C184.952 46.3149 193.691 37.5759 193.691 26.7957C193.691 16.0154 184.952 7.27637 174.172 7.27637C163.391 7.27637 154.652 16.0154 154.652 26.7957C154.652 37.5759 163.391 46.3149 174.172 46.3149Z",
    fill: "url(#paint3_linear_13739_143902)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 52.5527,
    y: 75.5928,
    width: 105.104,
    height: 76.3755,
    rx: 9.0089,
    fill: "url(#paint4_linear_13739_143902)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_13739_143902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.5684 58.3257C67.5684 55.838 69.5851 53.8213 72.0728 53.8213L138.138 53.8213C140.626 53.8213 142.643 55.838 142.643 58.3257V118.385C142.643 120.873 140.626 122.89 138.138 122.89L72.0728 122.89C69.5851 122.89 67.5684 120.873 67.5684 118.385L67.5684 58.3257Z",
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 105.48,
    cy: 85.7276,
    r: 16.8917,
    fill: "#4251DA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.57 76.5869C107.269 76.5869 108.838 77.0071 110.276 77.8475C111.714 78.6879 112.853 79.8271 113.694 81.265C114.534 82.703 114.954 84.2717 114.954 85.9712C114.954 88.5484 114.347 90.4065 113.133 91.5457C112.778 91.8632 112.368 92.1153 111.901 92.3021C111.434 92.4701 110.958 92.5542 110.472 92.5542C110.024 92.5542 109.604 92.4701 109.211 92.3021C108.782 92.1153 108.446 91.8445 108.203 91.4897C107.96 91.1162 107.839 90.6867 107.839 90.2011V89.2207C107.036 89.8743 106.111 90.2011 105.066 90.2011C104.3 90.2011 103.581 90.0144 102.909 89.6409C102.255 89.2487 101.732 88.7258 101.34 88.0721C100.966 87.4185 100.78 86.6995 100.78 85.9152C100.78 85.1495 100.966 84.4398 101.34 83.7862C101.732 83.1139 102.255 82.591 102.909 82.2175C103.581 81.8253 104.3 81.6292 105.066 81.6292C106.093 81.6292 107.017 81.9654 107.839 82.6377V81.6292H109.744V88.9966V90.2011C109.744 90.2945 109.753 90.3692 109.772 90.4252C109.809 90.4626 109.874 90.4999 109.968 90.5373C110.117 90.5933 110.285 90.6213 110.472 90.6213C111.032 90.6213 111.481 90.4626 111.817 90.1451C112.638 89.3607 113.049 87.9694 113.049 85.9712C113.049 84.6266 112.713 83.3847 112.041 82.2455C111.368 81.1063 110.453 80.2006 109.296 79.5283C108.156 78.8559 106.914 78.5198 105.57 78.5198C104.225 78.5198 102.983 78.8559 101.844 79.5283C100.705 80.2006 99.7992 81.1063 99.1269 82.2455C98.4546 83.3847 98.1184 84.6266 98.1184 85.9712C98.1184 87.3158 98.4546 88.567 99.1269 89.7249C99.7992 90.8641 100.705 91.7698 101.844 92.4421C102.983 93.1144 104.225 93.4506 105.57 93.4506C106.205 93.4506 106.83 93.3666 107.447 93.1985L107.923 95.0753C107.195 95.2621 106.41 95.3555 105.57 95.3555C103.87 95.3555 102.302 94.9353 100.864 94.0949C99.4444 93.2545 98.3052 92.1153 97.4461 90.6773C96.6057 89.2393 96.1855 87.6706 96.1855 85.9712C96.1855 84.2717 96.6057 82.703 97.4461 81.265C98.3052 79.8271 99.4444 78.6879 100.864 77.8475C102.302 77.0071 103.87 76.5869 105.57 76.5869ZM105.066 88.2962C105.719 88.2962 106.279 88.0628 106.746 87.5959C107.213 87.129 107.447 86.5688 107.447 85.9152C107.447 85.2615 107.213 84.7106 106.746 84.2624C106.279 83.7955 105.719 83.5621 105.066 83.5621C104.431 83.5621 103.88 83.7955 103.413 84.2624C102.946 84.7106 102.713 85.2615 102.713 85.9152C102.713 86.5688 102.937 87.129 103.385 87.5959C103.852 88.0628 104.412 88.2962 105.066 88.2962Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_13739_143902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.5527 96.6133L101.759 116.296C103.907 117.155 106.303 117.155 108.45 116.296L157.657 96.6133V142.959C157.657 147.935 153.623 151.968 148.648 151.968H61.5616C56.5862 151.968 52.5527 147.935 52.5527 142.959V96.6133Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_13739_143902",
    x: 18.7685,
    y: 130.397,
    width: 60.0587,
    height: 60.0596,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.50148,
    result: "effect1_foregroundBlur_13739_143902"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_13739_143902",
    x: 58.5595,
    y: 47.8154,
    width: 93.092,
    height: 87.0862,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.00297
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.50445
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.427451 0 0 0 0 0.537255 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13739_143902"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13739_143902",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_13739_143902",
    x: 43.5438,
    y: 86.8536,
    width: 123.121,
    height: 73.3723,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.750742
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.50445
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.427451 0 0 0 0 0.537255 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13739_143902"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13739_143902",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13739_143902",
    x1: 21.378,
    y1: 42.9772,
    x2: 36.832,
    y2: 13.4457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4645ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442479,
    stopColor: "#4C5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13739_143902",
    x1: 168.744,
    y1: 177.832,
    x2: 175.593,
    y2: 164.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4645ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442479,
    stopColor: "#4C5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13739_143902",
    x1: 20.8083,
    y1: 200.691,
    x2: 58.7412,
    y2: 128.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4645ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442479,
    stopColor: "#4C5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13739_143902",
    x1: 153.957,
    y1: 55.8751,
    x2: 181.353,
    y2: 3.61899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4645ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442479,
    stopColor: "#4C5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_13739_143902",
    x1: 105.105,
    y1: 75.5928,
    x2: 105.105,
    y2: 151.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE1E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmEmail);
export default __webpack_public_path__ + "static/media/confirm-email.d47465adf9f2e7df76d137d8667b16d7.svg";
export { ForwardRef as ReactComponent };